module.exports = __webpack_public_path__ + "img/40-s.b6b005f1.png";